import http from "src/utils/axios";

export const fetchChartProfitApi = async (payload = {}, cancelToken) => {
  let queryString = Object.keys(payload).map(key => {
    return `${encodeURIComponent(key)}=${Array.isArray(payload[key]) ? payload[key].map(e => encodeURIComponent(e)).join(",") : encodeURIComponent(payload[key])}`;
  }).join("&")

  return http.get(`/v1/stats/profit?${queryString}`, true, cancelToken);
};

export const fetchChartUserApi = async (payload = {}, cancelToken) => {
  let queryString = Object.keys(payload).map(key => {
    return `${encodeURIComponent(key)}=${Array.isArray(payload[key]) ? payload[key].map(e => encodeURIComponent(e)).join(",") : encodeURIComponent(payload[key])}`;
  }).join("&")

  return http.get(`/v1/stats/user?${queryString}`, true, cancelToken);
};

export const fetchChartAllocatedApi = async (payload = {}, cancelToken) => {
  let queryString = Object.keys(payload).map(key => {
    return `${encodeURIComponent(key)}=${Array.isArray(payload[key]) ? payload[key].map(e => encodeURIComponent(e)).join(",") : encodeURIComponent(payload[key])}`;
  }).join("&")

  return http.get(`/v1/stats/allocated?${queryString}`, true, cancelToken);
};


export const fetchChartAvailableApi = async (payload = {}, cancelToken) => {
  let queryString = Object.keys(payload).map(key => {
    return `${encodeURIComponent(key)}=${Array.isArray(payload[key]) ? payload[key].map(e => encodeURIComponent(e)).join(",") : encodeURIComponent(payload[key])}`;
  }).join("&")

  return http.get(`/v1/stats/available?${queryString}`, true, cancelToken);
};

export const fetchLastStatsApi = async (cancelToken) => {
  return http.get(`/v1/stats/last`, true, cancelToken);
};

export const getStatsLinePartner = async (date) => {
  return http.get(`/v1/partners/dashboard/line-chart?startDate=${date}`);
};

export const getStatsPartner = async () => {
  return http.get(`/v1/partners/dashboard/stats`);
};

export const getThresholdsPartner = async () => {
  return http.get(`/v1/partners/thresholds/reach`);
};

export const getRolesMePartner = async () => {
  return http.get(`/v1/partners/roles/me`);
};